import React from 'react';
import './School.css';

import iconHome from '../../assets/icons/home-icon.png';
import iconEsmia from '../../assets/icons/ESMIA.png';
import iconODC from '../../assets/icons/odc.png';

import home from '../../assets/images/desktop.jpg';
import esmia from '../../assets/images/esmia.jpg';
import odc from '../../assets/images/odc.jpeg';

import SchoolCard from './SchoolCards';

const schools = [
  {
    image: home,
    place: 'Home',
    caption: 'The place where I gained the most knowledge about programming languages, libraries like ReactJS, frameworks such as Symfony, and more.',
    logo: iconHome,
    backgroundColor: '#1163e2bf',
    color: '#ffffff',
    altText: 'Home programming learning environment',
    logoAltText: 'Home logo',
  },
  {
    image: esmia,
    place: 'ESMIA',
    caption: 'At ESMIA, I learned the basics of coding, business promotion, digital marketing, management, dashboard development (KPIs), data analysis (AFC, CAH, ACP...), and an introduction to AI.',
    logo: iconEsmia,
    backgroundColor: '#f1e20bbf',
    color: '#041f60',
    altText: 'ESMIA campus',
    logoAltText: 'ESMIA logo',
  },
  {
    image: odc,
    place: 'ODC',
    caption: 'I acquired web development skills at ODC: HTML5, CSS3, JavaScript, PHP, MySQL, Agile methodology, and Git.',
    logo: iconODC,
    backgroundColor: '#f19407bf',
    color: '#0a0a0a',
    altText: 'ODC campus',
    logoAltText: 'ODC logo',
  },
];

export default function School() {
  return (
    <section className="school-section-wrapper">
      <div className="grain" aria-hidden="true" />

      <div className="school-container">
        <div className="school-header">
          <div className="section-label">Education</div>
          <h2>Where did I learn to code?</h2>
        </div>

        <div className="schools">
          {schools.map((school, i) => (
            <SchoolCard key={i} {...school} />
          ))}
        </div>
      </div>
    </section>
  );
}